<script>
const sidebarMenu = [
  // { path: '/', icon: 'fa fa-th', title: 'Home' },

  //ValidasiKedatanganTruck
  { path: "/dashboard/validasi-kedatangan-truck", font: "normal normal normal 16px/25px Poppins", icon: "icon mdi--truck-check", title: "Validasi Ked. Truck" },

  //Activities
  { path: "/dashboard/pengecekan", icon: "icon fluent--task-list-square-ltr-16-filled", title: "Pengecekan TO", font: "normal normal normal 16px/25px Poppins" },

  //Consumer Insights
  // { path: '/dashboard/consumer-insights', icon: 'far fa-users', title: 'Consumer Insight' },

  //Pengiriman
  { path: "/dashboard/pengiriman", icon: "icon iconamoon--delivery-fast-fill", title: "Pengiriman", font: "normal normal normal 16px/25px Poppins" },

  //Pengecekan Truck
  { path: "/dashboard/pengecekan-antrian-truck",  icon: "icon mdi--truck-check", title: "Antrian Truck", font: "normal normal normal 16px/25px Poppins"},

  //Monitoring
  {
    path: "/dashboard/monitoring",
    icon: "icon monitor",
    title: "Monitoring",
    font: "normal normal normal 16px/25px Poppins",
    children: [
      { path: "/dashboard/monitoring/status-truk", title: "Status Truk" },
      { path: "/dashboard/monitoring/kelola-status", title: "Kelola Status", type: "ADMIN" },
      { path: "/dashboard/monitoring/status-sj", title: "Status SJ" },
      { path: "/dashboard/monitoring/status-to", title: "Status TO" },
    ],
  },
  //Report
  { path: "/dashboard/report", icon: "icon mdi--file-report", title: "Report", font: "normal normal normal 16px/25px Poppins" },

  //Truck Tracking
  { path: "/dashboard/truck-tracking", icon: "icon truck-location", title: "Truck Tracking", font: "normal normal normal 16px/25px Poppins" },

  //Pengecekan Truck
  { path: "/dashboard/pengecekan-truck", icon: "icon mdi--truck-minus", title: "Pengecekan Truck", font: "normal normal normal 16px/25px Poppins", type: "ADMIN" },

  //Settings
  {
    path: "/dashboard/settings",
    icon: "fas fa-cog icon icon-settings",
    title: "Settings",
    font: "normal normal normal 16px/25px Poppins",
    children: [
      { path: "/dashboard/settings/user-mobile", icon: "fas fa-user", title: "User Driver Security", type: "GUDANG" },
      { path: "/dashboard/settings/user-management", icon: "fas fa-user", title: "User Management", type: "ADMIN" },
      { path: "/dashboard/settings/dealer-status", icon: "fas fa-home-alt", title: "Dealer Status", type: "ADMIN" },
      { path: "/dashboard/settings/nopol-truck", icon: "far fa-truck", title: "NOPOL Truck", type: "ADMIN" },
      { path: "/dashboard/settings/user-ekspedisi", icon: "fas fa-home-alt", title: "User Ekspedisi", type: "ADMIN" },
      { path: "/dashboard/settings/user-question", icon: "far fa-comment-dots", title: "User Question Truck", type: "ADMIN" },
      { path: "/dashboard/settings/user-officer", icon: "", title: "User Officer", type: "ADMIN" },
      { path: "/dashboard/settings/master-container", icon: "", title: "Jenis Truck", type: "ADMIN" },
    ],
  },

  //CSO
  // { path: '/cso', icon: 'fas fa-table', title: 'CSO',
  //   children: [
  //     { path: '/cso/exit-permit', title: 'Gatepass' },
  //     { path: '/cso/customer-quotation', title: 'Quotation' },
  //     { path: '/cso/insurance-policy', title: 'Insurance Policy' },
  //     { path: '/cso/master-data', title: 'Master Data',
  //       children: [
  //         { path: '/cso/master-data/color', title: 'Warna Mobil' },
  //         { path: '/cso/master-data/brand-&-type', title: 'Merk Dan Tipe Mobil' },
  //         { path: '/cso/master-data/customer', title: 'Pelanggan' },
  //         { path: '/cso/master-data/customer-car', title: 'Mobil Pelanggan' },
  //         { path: '/cso/master-data/laborer', title: 'Pekerja' },
  //         { path: '/cso/master-data/supplier', title: 'Supplier' },
  //       ]
  //     },
  //   ]
  // },
];

export default sidebarMenu;
</script>
